// Maps backend `WorkspaceModule.code` to a `common:nav.*` i18n key.
//
// The backend (`backend/internal/workspaces/workspaces.go`) returns module
// labels in French only. Rather than duplicate the catalog server-side,
// we look up the i18n key here and fall back to the backend label if no
// mapping exists — so a new module shipped from the backend renders even
// before this map is updated.
export const MODULE_LABEL_KEYS: Record<string, string> = {
  // my workspace
  'my-home': 'common:nav.my_space',
  'my-profile': 'common:nav.my_profile',
  'my-documents': 'common:nav.my_documents',
  'my-leaves': 'common:nav.my_leaves',
  'my-attendance': 'common:nav.my_attendance',
  'my-payslips': 'common:nav.my_payslips',
  'my-advances': 'common:nav.my_advances',
  'my-settings': 'common:settings',

  // operations (workspace "Dédouanement")
  'customs-dashboard': 'common:nav.customs_dashboard',
  'customs-simulation': 'common:nav.customs_simulation',
  'customs-dossiers': 'common:nav.customs_dossiers',
  'customs-circuit': 'common:nav.customs_circuit',
  'customs-suspensive': 'common:nav.customs_suspensive',
  'customs-reports': 'common:nav.customs_reports',
  'freight-desk': 'common:nav.freight_sea',
  'freight-air': 'common:nav.freight_air',
  'freight-road': 'common:nav.freight_road',
  'freight-companies': 'common:nav.freight_companies',
  shipments: 'common:nav.shipments',
  'shipments-map': 'common:nav.shipments_map',
  bookings: 'common:nav.bookings',
  customs: 'common:nav.customs',
  warehouse: 'common:nav.warehouse',
  'warehouse-board': 'common:nav.warehouse',
  'warehouse-reception': 'common:nav.warehouse_reception',
  'warehouse-putaway': 'common:nav.warehouse_putaway',
  'warehouse-handover': 'common:nav.warehouse_handover',
  'warehouse-control': 'common:nav.warehouse_control',
  'warehouse-billing': 'common:nav.warehouse_billing',
  'warehouse-leases': 'common:nav.warehouse_leases',
  'warehouse-sites': 'common:nav.warehouse_sites',
  'warehouse-stock': 'common:nav.warehouse_stock',
  'warehouse-inventory': 'common:nav.warehouse_inventory',
  'warehouse-move-in': 'common:nav.warehouse_move_in',

  // commercial
  quotes: 'common:nav.quotes',
  customers: 'common:nav.customers',
  invoices: 'common:nav.invoices',
  crm: 'crm:dashboard',
  'crm-customers': 'crm:customers',
  'crm-pipeline': 'crm:pipeline.title',
  'crm-leads': 'crm:leads.title',
  'crm-activities': 'crm:activities.title',
  'crm-forecast': 'crm:forecast.title',
  'crm-churn-risk': 'crm:churn_risk',
  'crm-settings': 'common:nav.crm_settings',

  // hr
  hr: 'common:nav.hr',
  'hr-employees': 'common:nav.hr_employees',
  'hr-leaves': 'common:nav.hr_leaves',
  'hr-leaves-calendar': 'common:nav.hr_leaves_calendar',
  'hr-contracts': 'common:nav.hr_contracts',
  'hr-attendance': 'common:nav.hr_attendance',
  'hr-documents': 'common:nav.hr_documents',
  'hr-advances': 'common:nav.advances_admin',
  'hr-analytics': 'common:nav.hr_analytics',

  // payroll
  payroll: 'common:nav.payroll',
  'payroll-periods': 'common:nav.payroll_periods',
  'payroll-payslips': 'common:nav.payroll_payslips',
  'payroll-advances': 'common:nav.advances_admin',
  'payroll-declarations': 'common:nav.payroll_declarations',
  'payroll-analytics': 'common:nav.payroll_analytics',

  // accounting
  accounting: 'common:nav.accounting',
  'acc-balance': 'common:nav.accounting_trial_balance',
  'acc-income': 'common:nav.accounting_income',
  'acc-bs': 'common:nav.accounting_balance_sheet',
  'acc-journal': 'common:nav.accounting_entries',
  'acc-entry': 'common:nav.accounting_entry_new',
  'acc-vat': 'common:nav.accounting_vat',
  'acc-reconciliation': 'common:nav.accounting_reconciliation',
  'acc-accounts': 'common:nav.accounting_accounts',

  // finance
  'fin-dashboard': 'common:nav.finance_dashboard',
  'fin-ar': 'common:nav.finance_ar',
  payments: 'common:nav.payments',
  suppliers: 'suppliers:title',
  'vendor-bills': 'common:nav.vendor_bills',
  'vendor-payments': 'suppliers:vendor_payment.title',
  vat: 'common:nav.accounting_vat',
  expenses: 'common:nav.expenses_dashboard',
  'expenses-claims': 'common:nav.expenses_claims',
  'expenses-categories': 'common:nav.expenses_categories',

  // fleet (V1.5 foundations — M07 à venir)
  'fleet-dashboard': 'common:nav.fleet_dashboard',
  'fleet-vehicles': 'common:nav.fleet_vehicles',
  'fleet-drivers': 'common:nav.fleet_drivers',
  'fleet-missions': 'common:nav.fleet_missions',
  'fleet-fuel': 'common:nav.fleet_fuel',
  'fleet-maintenance': 'common:nav.fleet_maintenance',
  'fleet-incidents': 'common:nav.fleet_incidents',
  'fleet-gps': 'common:nav.fleet_gps',

  // compliance (V1.5 foundations — M04 à venir)
  'compl-dashboard': 'common:nav.compliance_dashboard',
  'compl-sanctions': 'common:nav.compliance_sanctions',
  'compl-anomalies': 'common:nav.compliance_anomalies',
  'compl-tax': 'common:nav.compliance_tax',
  'compl-payroll': 'common:nav.compliance_payroll',
  'compl-fiscal': 'common:nav.compliance_fiscal',

  // client portal
  'cp-shipments': 'common:nav.portal_shipments',
  'cp-quotes': 'common:nav.portal_quotes',
  'cp-bookings': 'common:nav.portal_bookings',
  'cp-invoices': 'common:nav.portal_invoices',

  // admin
  'admin-users': 'common:nav.admin_users',
  'admin-roles': 'common:nav.admin_roles',
  'admin-delegations': 'common:nav.admin_delegations',
  'admin-audit': 'common:nav.admin_audit',
  'admin-settings': 'common:nav.admin_settings',
}
